include ../../../../common/primary/icon/icon.mixin.pug

PageVue
  template(v-slot:body)
    LoginFormVue
